import React, { useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../css/ContactUs.css';
import '../css/about.css';
import '../css/contact-quote.css';

const OFFICES = [
    {
        code: 'EG',
        country: 'Egypt',
        tag: 'Head Office',
        entities: [
            {
                name: 'Petrochoice Integrated Services',
                address: 'Almaadadi–Takseem Alasilik-Hussein, Hamouda Street 12A/2, Cairo, Egypt',
                email: 'info@petrochoice.org'
            },
            {
                name: 'Petrochoice Integrated Services FZ',
                address: 'Free Zone, Al Amria, Alexandria, Egypt',
                email: 'info@petrochoice.org'
            }
        ]
    },
    {
        code: 'AE',
        country: 'United Arab Emirates',
        tag: 'Branch',
        entities: [
            {
                name: 'Petrochoice Integrated Services FZ LLC',
                address: 'VUPR0165 – Compass building – Al Hulaiah Industrial zone – FZ – Ras Al Khaimah – UAE',
                email: 'info@petrochoice.org'
            }
        ]
    }
];

const ContactUs = () => {
    const underlineRef = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (underlineRef.current) {
                underlineRef.current.classList.add('animate');
            }
        }, 50);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="pcf">
            {/* Hero */}
            <header
                className="pcf-hero"
                style={{ backgroundImage: "url('/assets/about1.png')" }}
            >
                <div className="container">
                    <span className="pcf-hero__eyebrow">
                        <i className="bi bi-chat-dots" /> Contact
                    </span>
                    <h1 className="pcf-hero__title">Get in Touch</h1>
                    <p className="pcf-hero__subtitle">
                        We&apos;re here to answer your questions and discuss how we can help.
                    </p>
                    <div className="pcf-rule" ref={underlineRef} />
                </div>
            </header>

            <section className="pcf-section">
                <div className="container">
                    <div className="row g-4">
                        {/* Form */}
                        <div className="col-lg-6">
                            <div className="pcf-card">
                                <div className="pcf-card__body">
                                    <h2 className="pcf-form-title">Send us a message</h2>
                                    <p className="pcf-form-note">
                                        Fill out the form and our team will get back to you as soon
                                        as possible.
                                    </p>

                                    <form>
                                        <div className="pcf-field">
                                            <label className="form-label" htmlFor="contact-name">
                                                Your Name
                                            </label>
                                            <input
                                                type="text"
                                                id="contact-name"
                                                name="name"
                                                className="form-control"
                                                placeholder="Your name"
                                                autoComplete="name"
                                            />
                                        </div>

                                        <div className="pcf-field">
                                            <label className="form-label" htmlFor="contact-email">
                                                Your Email
                                            </label>
                                            <input
                                                type="email"
                                                id="contact-email"
                                                name="email"
                                                className="form-control"
                                                placeholder="Your email"
                                                autoComplete="email"
                                            />
                                        </div>

                                        <div className="pcf-field">
                                            <label className="form-label" htmlFor="contact-subject">
                                                Subject
                                            </label>
                                            <select
                                                id="contact-subject"
                                                name="subject"
                                                className="form-select"
                                                defaultValue="General Inquiry"
                                            >
                                                <option>General Inquiry</option>
                                                <option>Business Partnership</option>
                                                <option>Technical Support</option>
                                                <option>Careers</option>
                                            </select>
                                        </div>

                                        <div className="pcf-field">
                                            <label className="form-label" htmlFor="contact-message">
                                                Your Message
                                                <span className="pcf-opt">(optional)</span>
                                            </label>
                                            <textarea
                                                id="contact-message"
                                                name="message"
                                                className="form-control"
                                                rows="5"
                                                placeholder="Your message"
                                            />
                                        </div>

                                        <div className="pcf-actions">
                                            <button type="submit" className="pcf-btn pcf-btn--primary">
                                                <i className="bi bi-send" /> Submit
                                            </button>
                                            <button type="reset" className="pcf-btn pcf-btn--quiet">
                                                Reset
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        {/* Offices */}
                        <div className="col-lg-6">
                            {OFFICES.map((office) => (
                                <div className="pcf-card pcf-office" key={office.code}>
                                    <div className="pcf-office__head">
                                        <span className="pcf-office__code">{office.code}</span>
                                        <h3 className="pcf-office__name">{office.country}</h3>
                                        <span className="pcf-office__tag">{office.tag}</span>
                                    </div>

                                    {office.entities.map((entity) => (
                                        <div className="pcf-entity" key={entity.name + entity.address}>
                                            <h4 className="pcf-entity__name">{entity.name}</h4>
                                            <ul className="pcf-lines">
                                                <li>
                                                    <i className="bi bi-geo-alt-fill" />
                                                    <span>{entity.address}</span>
                                                </li>
                                                <li>
                                                    <i className="bi bi-envelope-fill" />
                                                    <span>
                                                        <a href={`mailto:${entity.email}`}>{entity.email}</a>
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ContactUs;
